import React from 'react';
import { motion } from 'framer-motion';
import { OnboardingBackButton } from '../OnboardingBackButton';

export const HostOnboardingShell = ({
  children,
  footer,
  onBack,
  pageTestId,
  backTestId,
  logoTestId,
  scrollable = false,
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.45, ease: [0.25, 0.1, 0.25, 1] }}
      className="app-shell premium-page"
      data-testid={pageTestId}
      style={{
        height: '100dvh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: 'var(--app-bg)',
        position: 'relative',
        padding: '0 24px 0',
        overflow: 'hidden',
      }}
    >
      {/* Top header row: back arrow lives here so the Admin pill (top-left, safe-area+72)
          can sit under it without visual collision. Padding matches
          VenueIntroPage's absolute-positioned back button (safe-area + 20,
          x=20) so the arrow visually lines up across host + venue intros. */}
      <div
        style={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          flexShrink: 0,
          paddingTop: 'calc(env(safe-area-inset-top, 0px) + 20px)',
          paddingBottom: 8,
          marginLeft: -4,
        }}
      >
        <OnboardingBackButton
          onClick={onBack}
          testId={backTestId}
        />
      </div>

      {/* Logo — sized + spaced so it sits below the Admin pill zone
          (safe-area + 72px) without cramping. */}
      <img
        src="/allure-logo.png"
        alt="Allure"
        data-testid={logoTestId}
        style={{ width: 110, height: 98, objectFit: 'contain', marginTop: 44, flexShrink: 0 }}
      />

      <div
        style={{
          width: '100%',
          maxWidth: 342,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          flex: 1,
          overflowY: scrollable ? 'auto' : 'hidden',
          WebkitOverflowScrolling: 'touch',
          justifyContent: scrollable ? 'flex-start' : 'center',
          paddingTop: scrollable ? 20 : 0,
          paddingBottom: scrollable ? 8 : 0,
        }}
      >
        {children}
      </div>

      {footer ? (
        <div style={{ width: '100%', maxWidth: 342, padding: '16px 0', paddingBottom: 'calc(env(safe-area-inset-bottom, 0px) + 20px)', flexShrink: 0, display: 'flex', justifyContent: 'center' }}>
          {footer}
        </div>
      ) : null}
    </motion.div>
  );
};
